import {
  customerStageBadgeTone,
  formatCustomerStage,
} from '@proffer/shared'
import { AppBadge, type AppTone } from '../UI'

export function CustomerStageBadge({
  stage,
  className,
}: {
  stage: string
  className?: string
}) {
  const tone = customerStageBadgeTone(stage) as AppTone
  return (
    <AppBadge tone={tone} className={className}>
      {formatCustomerStage(stage)}
    </AppBadge>
  )
}
